import {Component, OnInit, signal} from '@angular/core';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {CustomerArea} from '../../classes/customerarea.class';
import {CustomerAreaService} from '../../services/consumer-area/customer-area.service';
import {CordovaService} from "../../cordova.service";
import {ConfirmDialogService} from "../../services/confirm-dialog-service/confirm-dialog.service";
import {CodaltComponent} from '../../codalt.component';
import {Customer} from '../../classes/customer';
import {VvrIconComponent} from "../../vvr-icon/vvr-icon.component";
import {MatTooltip} from "@angular/material/tooltip";
import {NgLabelTemplateDirective, NgOptionTemplateDirective, NgSelectComponent, NgTagTemplateDirective} from "@ng-select/ng-select";
import {MatError, MatFormField, MatInput} from "@angular/material/input";
import {MatCheckbox} from "@angular/material/checkbox";
import {MatButton} from "@angular/material/button";

@Component({
    selector: 'app-customer-area-edit',
    templateUrl: './customer-area-edit.component.html',
    styleUrls: ['./customer-area-edit.component.scss'],
    imports: [
        VvrIconComponent,
        MatTooltip,
        RouterLink,
        ReactiveFormsModule,
        NgSelectComponent,
        NgTagTemplateDirective,
        NgLabelTemplateDirective,
        NgOptionTemplateDirective,
        MatFormField,
        MatInput,
        MatError,
        MatCheckbox,
        MatButton
    ]
})
export class CustomerAreaEditComponent extends CodaltComponent implements OnInit {

    readonly saving = signal<boolean>(false);

    customerArea: CustomerArea;
    readonly customers = signal<Customer[]>([]);

    readonly form = signal<FormGroup>(null);
    private groupControl: FormControl;

    constructor(
        private route: ActivatedRoute,
        private cordovaService: CordovaService,
        private customerAreaService: CustomerAreaService,
        private confirmDialogService: ConfirmDialogService,
        private router: Router
    ) {
        super();
    }

    ngOnInit() {
        this.cordovaService.setBackbuttonAction(() => {
            this.router.navigate(['/customer-areas']);
        });
        this.route.params.subscribe(params => {
            const customerAreaId = +params['customerAreaId'];
            if (customerAreaId) {
                this.getCustomerArea(customerAreaId);
            } else {
                this.customerArea = new CustomerArea();
                this.setFormGroup(this.customerArea);
            }
        });
        this.loadCustomers();
    }

    addCustomerToArea(customer: Customer) {
        this.form().get('customer_id').setValue(customer.id);
    }

    addTag = (name) => {
        return new Promise((resolve) => {
            const customer = new Customer();
            customer.name = name;
            this.customerAreaService.saveCustomer(customer).subscribe(newTag => {
                this.loadCustomers();
                resolve(newTag.data);
            }, error => {

            });
        });
    };

    save() {
        Object.assign(this.customerArea, this.form().value);
        this.saving.set(true);
        this.customerAreaService.save(this.customerArea).then(user => {
            this.saving.set(false);
            this.router.navigate([`customer-areas`]);

        }, error => {
            this.saving.set(false);
            this.confirmDialogService.confirm('Er ging iets fout', error['error']['error']['errormessage']);
        });
    }

    private loadCustomers() {
        this.subscriptions.add(this.customerAreaService.getCustomers().subscribe(customers => {
            this.customers.set(customers.data);
        }));
    }

    private getCustomerArea(id) {
        this.customerAreaService.getList().then(customerAreas => {
            this.customerArea = customerAreas.find(p => p.id === id);
            this.setFormGroup(this.customerArea);
        });
    }

    private setFormGroup(customerArea: CustomerArea) {
        this.form.set(
            new FormGroup({
                name: new FormControl(customerArea.name, [Validators.required, Validators.minLength(3)]),
                kind: new FormControl(customerArea.kind, Validators.required),
                street: new FormControl(customerArea.street),
                number: new FormControl(customerArea.number),
                zip: new FormControl(customerArea.zip),
                city: new FormControl(customerArea.city),
                phone: new FormControl(customerArea.phone),
                notifications: new FormControl(customerArea.notifications),
                customer_id: new FormControl(customerArea.customer_id)
            })
        );
    }
}
